import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import myLogo from "../../assets/images/my_logo4.png";
import AppNavbar from "../common/AppNavbar";

// 🖥️ Desktop Navbar
const DesktopNav = () => (
  <div className="d-none d-lg-block">
    {/* Logo Center */}
    <Navbar>
      <Container className="d-flex justify-content-center py-2">
        <Navbar.Brand as={Link} to="/">
          <img
            src={myLogo}
            alt="Bharat Heritage"
            className="img-fluid"
            style={{ height: "100px" }}
          />
        </Navbar.Brand>
      </Container>
    </Navbar>

    {/* Section Title */}
    <Navbar bg="light" className="border-bottom">
      <Container fluid className="d-flex justify-content-start">
        <h5 className="ps-2 fw-bold mb-0">BHARAT HERITAGE</h5>
      </Container>
    </Navbar>

    {/* Category Menu */}
    <Navbar bg="light">
      <Container fluid>
        <Nav
          className="fw-bold"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            padding: "6px 0",
          }}
        >
          <Nav.Link as={Link} to="/heritage/food">
            Food
          </Nav.Link>
          <Nav.Link as={Link} to="/heritage/fitness">
            Fitness
          </Nav.Link>
          <Nav.Link as={Link} to="/heritage/beauty">
            Beauty
          </Nav.Link>
          {/* <Nav.Link as={Link} to="/heritage/fashion">
            Fashion
          </Nav.Link> */}
          {/* Future */}
          {/* <Nav.Link as={Link} to="/heritage/astrology">Astrology</Nav.Link>
          <Nav.Link as={Link} to="/heritage/shopping">Shopping</Nav.Link> */}
        </Nav>
      </Container>
    </Navbar>
  </div>
);

// 📱 Mobile Navbar
const MobileNav = () => (
  <div className="d-lg-none">
    {/* Logo */}
    <div style={{ background: "#fff", borderBottom: "1px solid #ddd" }}>
      <Navbar.Brand as={Link} to="/">
        <Container fluid className="py-2 d-flex align-items-center">
          <img
            src={myLogo}
            alt="Bharat Heritage"
            className="img-fluid"
            style={{ height: "40px" }}
          />
        </Container>
      </Navbar.Brand>
    </div>

    {/* Scrollable Categories */}
    <div
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        borderBottom: "1px solid #ddd",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Nav
        className="fw-bold text-secondary"
        style={{
          display: "inline-flex",
          flexWrap: "nowrap",
          gap: "20px",
          padding: "10px",
          fontSize: "14px",
        }}
      >
        <Nav.Link as={Link} className="text-secondary" to="/heritage/food">
          Food
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/heritage/fitness">
          Fitness
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/heritage/beauty">
          Beauty
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/heritage/fashion">
          Fashion
        </Nav.Link>
      </Nav>
    </div>
  </div>
);

// 🌐 Main Heritage NavigationBar
const NavigationBar = () => (
  <>
    <DesktopNav />
    <MobileNav />
  </>
);

export default NavigationBar;
